import { memo } from 'react';

import { TextProps } from '@chakra-ui/react';

import { extractNumbers } from 'utils';

import { Text } from 'ui/Text';

interface CardNumberProps extends TextProps {
  cardNumber: string;
}

const CardNumber = ({ cardNumber, ...props }: CardNumberProps) => (
  <Text
    fontSize={{ base: 24, md: 32 }}
    lineHeight={{ base: 'auto', md: '43px' }}
    fontWeight='semibold'
    letterSpacing={2}
    width={{ base: '100%', lg: '50%' }}
    whiteSpace='nowrap'
    textAlign='right'
    {...props}
  >
    {`x${extractNumbers(cardNumber)}`}
  </Text>
);

export default memo(CardNumber);
